import React from 'react';
import { ThemeProvider, useMediaQuery, useTheme } from '@material-ui/core';
import { CapaQuotationPartnerEquipment } from '@generated/graphql';
import { DialogProps } from '@routes/CompanyInfo/types';
import EquipmentDetailInformation from './DetailViewInforamtion/EquipmentDetailInformation';
import DetailViewDialog from './DetailViewDialog';
import { colorSet, theme as defaultTheme } from '@components/Provider';
import { ChevronLeft } from '@carbon/icons-react';

interface EquipmentDetailViewProps extends DialogProps {
  equipment: CapaQuotationPartnerEquipment;
}

const EquipmentDetailView: React.FunctionComponent<EquipmentDetailViewProps> = ({
  open,
  onClose,
  equipment
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up(1200));
  const files = equipment.file ? [equipment.file] : [];
  const noFile = files.length === 0;

  return (
    <ThemeProvider theme={defaultTheme}>
      <DetailViewDialog
        isOpen={open}
        onClose={onClose}
        maxWidth={isDesktop ? (noFile ? 344 : 1024) : undefined}
        closeIcon={
          !isDesktop && noFile ? (
            <ChevronLeft size={24} color={colorSet.gray900} />
          ) : undefined
        }
      >
        {!noFile && (
          <DetailViewDialog.MediaSwiper backgroundColor="black" files={files} />
        )}
        <EquipmentDetailInformation equipment={equipment} />
      </DetailViewDialog>
    </ThemeProvider>
  );
};

export default EquipmentDetailView;
